import {Spinner, styled} from '@volkswagen-onehub/components-core'

import React from 'react'
import type {DefaultTheme} from 'styled-components'

const LoadingContainer = styled.div`
    background: ${({theme}: {theme: DefaultTheme}) =>
        theme.colors.background.primary};
    position: relative;
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    left: 0;
    top: 0;
    z-index: 1;
    justify-content: center;
`

export function Loading({className}: {className?: string}): React.JSX.Element {
    return (
        <LoadingContainer className={className}>
            <Spinner variant="x-large" />
        </LoadingContainer>
    )
}
